import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatPrice' })
export class FormatPricePipe implements PipeTransform {
  transform(amount: number): string {
    return `${amount.toFixed(2).replace('.', ',')}€`;
  }
}
